<template>
  <div class="tool-size">
    <div class="row -mx-0 align-items-center">
      <div class="col-auto px-0">
        <NormalSelect
          :variant="'select-transparent'"
          :selected="_value"
          :options="options"
          :optionValue="'value'"
          :optionLabel="'text'"
          :menuMaxHeight="'300px'"
          :block="false"
          :paddingSize="'small'"
          @change="(value) => { $emit('change', value) }"
        />
      </div>
    </div>
  </div>
</template>

<script>
import NormalSelect from "@components_system/Shared/Tools/NormalSelect/NormalSelect";
export default {
  components: {
    NormalSelect,
  },
  props: {
    value: {
      default: 16,
    },
    optionSize: {
      default: undefined,
    }
  },
  data() {
    return {
      optionsDefault: [
        { value: 8, text: "8 px" },
        { value: 9, text: "9 px" },
        { value: 10, text: "10 px" },
        { value: 11, text: "11 px" },
        { value: 12, text: "12 px" },
        { value: 13, text: "13 px" },
        { value: 14, text: "14 px" },
        { value: 15, text: "15 px" },
        { value: 16, text: "16 px" },
        { value: 17, text: "17 px" },
        { value: 18, text: "18 px" },
        { value: 19, text: "19 px" },
        { value: 20, text: "20 px" },
        { value: 22, text: "22 px" },
        { value: 24, text: "24 px" },
        { value: 26, text: "26 px" },
        { value: 28, text: "28 px" },
        { value: 30, text: "30 px" },
        { value: 32, text: "32 px" },
        { value: 34, text: "34 px" },
        { value: 36, text: "36 px" },
        { value: 40, text: "40 px" },
        { value: 44, text: "44 px" },
        { value: 48, text: "48 px" },
        { value: 52, text: "52 px" },
        { value: 56, text: "56 px" },
        { value: 60, text: "60 px" },
        { value: 66, text: "66 px" },
        { value: 72, text: "72 px" },
        { value: 80, text: "80 px" },
        { value: 100, text: "100 px" },
        { value: 140, text: "140 px" },
        { value: 160, text: "160 px" },
        { value: 180, text: "180 px" },
        { value: 200, text: "200 px" },
      ],
      optionsTextIcon: [
        { value: 8, text: "8 px" },
        { value: 9, text: "9 px" },
        { value: 10, text: "10 px" },
        { value: 11, text: "11 px" },
        { value: 12, text: "12 px" },
        { value: 13, text: "13 px" },
        { value: 14, text: "14 px" },
        { value: 15, text: "15 px" },
        { value: 16, text: "16 px" },
        { value: 17, text: "17 px" },
        { value: 18, text: "18 px" },
        { value: 19, text: "19 px" },
        { value: 20, text: "20 px" },
        { value: 22, text: "22 px" },
        { value: 24, text: "24 px" },
        { value: 26, text: "26 px" },
        { value: 28, text: "28 px" },
        { value: 30, text: "30 px" },
        { value: 32, text: "32 px" },
        { value: 34, text: "34 px" },
        { value: 36, text: "36 px" },
        { value: 40, text: "40 px" },
        { value: 44, text: "44 px" },
        { value: 48, text: "48 px" },
        { value: 52, text: "52 px" },
        { value: 56, text: "56 px" },
        { value: 60, text: "60 px" },
        { value: 66, text: "66 px" },
        { value: 72, text: "72 px" },
        { value: 80, text: "80 px" },
        { value: 100, text: "100 px" },
        { value: 140, text: "140 px" },
        { value: 160, text: "160 px" },
        { value: 180, text: "180 px" },
        { value: 200, text: "200 px" },
      ],
    }
  },
  computed: {
    options() {
      return this.optionSize == "textIcon" ? this.optionsTextIcon
        : this.optionsDefault;
    },
    _value() {
      const size = Array.isArray(this.value)
        ? this.value[0]
        : this.value;
      const findFont = this.options.filter(
        (item) => size && item.value == `${size}`.replace("px", "")
      )[0];
      return findFont ? findFont.value : null;
    },
  },
};
</script>

<style>
  .tool-size .mwe-normalselect .btn {
    padding-left: 0px !important;
    padding-right: 16px !important;
  }
  .tool-size .mwe-normalselect .dropdown-select.dropdown .dropdown-toggle::after {
    right: 0px !important;
  }
</style>